<template>
  <component
    :is="advertisement.link_url ? 'a' : 'div'"
    :href="advertisement.link_url"
    :target="advertisement.link_url ? '_blank' : null"
    :rel="advertisement.link_url ? 'sponsored noopener' : null"
    class="advertisement-visual d-block mt-3 rounded-4 overflow-hidden screen-content"
  >
    <img
      :src="advertisement.url"
      :srcset="advertisement.srcset"
      sizes="(max-width: 502px) calc(100vw - 2rem), 470px"
      :width="advertisement.width"
      :height="advertisement.height"
      :alt="alt"
      loading="lazy"
    >
  </component>
</template>

<script>
export default {
  name: 'AdvertisementVisual',

  props: {
    advertisement: {
      type: Object,
      required: true,
    },
  },

  computed: {
    /**
     * Alt text in the active language, falling back to Dutch.
     *
     * @return {String}
     */
    alt() {
      const texts = this.advertisement.alt || {};

      if (texts[this.$i18n.locale]) {
        return texts[this.$i18n.locale];
      }

      return texts.nl || '';
    },
  },
};
</script>
